<template>
  <AttrGroup title="序列帧默认图" tooltip="序列帧未播放时，显示的图片">
    <SpriteDefaultImageSectionSelect
      v-for="(spriteItem, index) in spriteItems"
      :key="spriteItem.id"
      :disabled="!!attrDisabled"
      :src="spriteImagesList(spriteItem.spriteImagesName as 'images')[spriteItem.spriteDefaultIndex??0]"
      :label="'序列帧' + (maxCount > 1 ? index + 1 : '')"
      :class="{
        'mt-2.5': index > 0
      }"
      @click="() => showModal(spriteItem)"
    />

    <a-modal
      v-model:visible="modalState.visible"
      title="选择序列帧图片"
      :width="1200"
      @after-close="() => afterClose()"
    >
      <div class="min-h-[300px] max-h-[800px] overflow-y-auto pb-4">
        <div class="grid grid-cols-7 gap-4 gap-y-6 cursor-pointer">
          <div
            v-for="(item, index) in modalState.images"
            :key="item + index"
            class="hover:opacity-80 hover:border-2 hover:border-blue/70 p-3"
            :class="{
              'border-2 border-blue': index === modalState.index
            }"
            @click="setSpriteDefaultIndex(index)"
          >
            <div>
              <img :src="item" :alt="'序列帧图片' + index" />
            </div>
            <div class="mt-2.5 text-center">
              {{ '第' + (index + 1) + '帧' }}
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <a-button type="primary" @click="handleok"> 关闭 </a-button>
      </template>
    </a-modal>
  </AttrGroup>
</template>

<script lang="ts" setup>
import { Shape } from '@/services/shape';
import { ResourceKey } from '@/services/shape/attributes';
import { SpriteAttribute } from '@/services/shape/attributes/sprite';
import { useEditorStore } from '@/store/use-editor-store';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { computed, nextTick } from 'vue';
import { PropType, ref } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  maxCount: {
    type: Number,
    default: 1
  },
  spriteItems: {
    type: Array as PropType<SpriteAttribute['spriteExtra']>,
    default: () => []
  }
});

const editorStore = useEditorStore();
const watcfaceStore = useWatchfaceStore();
const attrDisabled = computed(() => editorStore.attrDisabled);

const colorId = computed(() => {
  const colorId =
    watcfaceStore.colorMode == 'recolor'
      ? editorStore.theme?.colorGroupTable?.[0]?.id
      : editorStore.themeColor?.id;
  return colorId;
});

// modal
const modalState = ref({
  visible: false,
  index: 0,
  resourceName: '' as ResourceKey,
  images: [] as string[],
  spriteItemId: ''
});
const showModal = async (item: SpriteAttribute['spriteExtra'][number]) => {
  modalState.value.visible = true;
  const resourceName = item.spriteImagesName as 'images';
  modalState.value.resourceName = resourceName;
  await nextTick();
  modalState.value.images = spriteImagesList(resourceName);
  modalState.value.index = item.spriteDefaultIndex ?? 0;
  modalState.value.spriteItemId = item.id;
  modalState.value.visible = true;
};
const handleok = () => {
  modalState.value.visible = false;
};
const afterClose = () => {
  modalState.value.images = [];
  modalState.value.index = 0;
  modalState.value.resourceName = '' as ResourceKey;
  modalState.value.spriteItemId = '';
};

const spriteImagesList = (resourceName: ResourceKey) => {
  const imgsBase64 = props.shape.getResources({
    resourceName: resourceName,
    colorGroup: colorId.value ?? '',
    base64: true
  });
  return imgsBase64;
};

const setSpriteDefaultIndex = (index: number) => {
  const shape = props.shape;
  const extraId = modalState.value.spriteItemId;
  if (!extraId) {
    shape?.setAttrs({ spriteDefaultIndex: index });
  } else {
    shape.setAttrs({
      spriteExtra: shape.attrs.spriteExtra?.map((item) => {
        if (item.id == extraId) {
          return {
            ...item,
            spriteDefaultIndex: index
          };
        } else {
          return item;
        }
      })
    });
  }
  modalState.value.visible = false;
};
</script>
